import React, {Component} from 'react'
import SystemLabelMasterCollection from './../../collections/system_label_master_collection'

class SelectSoldOut extends Component {

  handleChange = (e) => {
    this.props.actions.changeSelectSoldOut({
      selectSoldOut: e.target.checked ? 'select_sold_out_include' : 'select_sold_out_exclude',
    })
  }

  render() {
    const {  payload } = this.props.systemLabelMastersApi
    if (!payload) {return null}
    new SystemLabelMasterCollection(payload)
    const {selectSoldOut} = this.props
    return (
      <div className='searchArea__item size-s'>
        <h3 className='searchArea__title'>{TRUCKERS.LANG.ITEM.LIST_SEARCH.SOLD}</h3>
        <div className="checkbox searchArea__item__inner">
          <input
            className="check"
            checked={(selectSoldOut == 'select_sold_out_include')}
            type="checkbox"
            name="select_sold_out"
            id="select_sold_out"
            onChange={this.handleChange}
          />
          <label htmlFor="select_sold_out">{"表示する"}</label>
        </div>
      </div>
    )
  }
}
export default SelectSoldOut
